var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 16,
    viewBox: "0 0 41 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H33C37.4183 0 41 3.58172 41 8C41 12.4183 37.4183 16 33 16H8C3.58172 16 0 12.4183 0 8Z",
    fill: "#C2D6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29695 12V4H10.504V10.9609H14.129V12H9.29695ZM16.933 4V12H15.7259V4H16.933ZM19.61 4L21.8366 10.5156H21.9264L24.153 4H25.4577L22.5787 12H21.1842L18.3053 4H19.61ZM26.8329 12V4H31.8486V5.03906H28.04V7.47656H31.5868V8.51172H28.04V10.9609H31.8954V12H26.8329Z",
    fill: "#162664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewLive);
export default __webpack_public_path__ + "static/media/interview-live.5c9d8216e28e26b1254962124e75f6cb.svg";
export { ForwardRef as ReactComponent };